<app-header></app-header>
<div class="single-blog-posts padd-row">
  <div class="container">
      <div class="single-blog-main clearfix">

          <div class="blog-single-heading">
              <h3 class="mb-4"> {{ blogData.title }} </h3>
              <div class="single-blog-meta-data">
                  <div style="cursor:pointer" [routerLink]="['/doctors/detail/'+blogData?.doctorId?.uniquekey]" class="single-blog-meta-data-img">
                      <img alt="" [src]="blogData?.doctorId?.profilePicture">
                  </div>
                  <div class="single-blog-meta-data-cnt">
                      <div *ngIf="blogData?.doctorId?.name" class="doc-name"> 
                        <a [routerLink]="['/doctors/detail/'+blogData?.doctorId?.uniquekey]">
                         {{ blogData?.doctorId?.name }}
                      </a>, {{ blogData?.doctorId?.speciality.join(',') }} 
                    </div>
                      <div class="meta-cmnt-likes">
                          <a (click)="loginFirstLike(review)" [class]="review.isLiked ? 'activeLike date-likes-main' : 'date-likes-main'" [routerLink]="null">

                              <img alt="" src="assets/images/heart.png">
                              <span > {{ blogData?.likeCount ? blogData?.likeCount : 0 }} Likes </span></a>
                          <a class="date-likes-main"  (click)="scrollToBottom(scrollMe)"  [routerLink]="null">
                            <img alt="" src="assets/images/chat-icon.png">
                            <span> {{ blogData?.commentCount ? blogData?.commentCount : 0 }} Comments
                               </span></a>
                      </div>
                      <div class="date"> {{ blogData.createdAt | date:'MMMM dd, y' }}</div>
                  </div>
              </div>
          </div>



      







          <div style="cursor:pointer" (click)="showImagePopup(blogData.image)" class="blog-single-img">
              <img [src]="blogData.image"> </div>
          <div class="blog-single-para">
              <p [innerHTML]="blogData.text">  </p>
              
          </div>
      </div>
  </div>
</div>



<div #scrollMe class="single-post-cmnt-sec padd-row pt-0">
    <div class="container">

        <div class="single-post-mtn-main-heading mb-5">
            <div class="d-md-flex">
                <h4 *ngIf="blogData?.reviews.length>0"> Comments </h4>
                <div (click)="loginFirst()" class="main-btn ml-auto">
                    <a [routerLink]="null" class="btn-style"> Add Comment </a>
                </div>
            </div>
        </div>
        <div class="single-post-cmnt-main">
            <div [hidden]="!reviews.comment" *ngFor="let reviews of blogData?.reviews" class="home_posts_box">
                <div class="row">
                    <div class="col-lg-2 col-md-3">
                        <div class="home_posts_box_heading p-0">
                            <div class="home_rightside_user_box">
                                <div class="home_rightside_user_box_img">
                                  <img alt="" [src]="reviews?.userId?.profilePicture"></div>
                                <div class="home_rightside_user_box_cnt" tabindex="0">
                                    <h4> {{ reviews?.userId?.name }}</h4>
                                    <p [innerHTML]="parseInt(getDays(reviews.createdAt)) !=0 ? parseInt(getDays(reviews.createdAt))+' days ago' : 'Today'"></p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-10 col-md-9">
                        <p> {{ reviews.comment }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>






  





<div class="share-post-btn-main">
  <share-buttons [title]="blogData.title" [image]="blogData.image" [include]="include"></share-buttons>
  <button class="form-control btn"  (click)="loginFirst()" ><img src="assets/images/chat-icon.png"></button>
  </div>
  

<input type="hidden" id="orderImagesCLick" data-toggle="modal" data-target="#orderImagesModal">

<!-- The Modal -->
<div class="modal fade"  id="orderImagesModal">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Image Preview</h5>
      </div>
      <!-- Modal body -->
      <div class="modal-body text-center">
            <slideshow
            [minHeight]="'525px'"
            [showArrows]="imageUrlArray.length>1 ? true: false"
            [imageUrls]="imageUrlArray"></slideshow>
        <button class="btn btn-primary" style="margin-top: 20px;"
 data-toggle="modal" data-target="#orderImagesModal">OK</button>

      </div>
    </div>
  </div>
</div>


<input type="hidden" id="add_comment_trigger" data-toggle="modal" data-target="#add-comment">
<!-- The Modal -->
<div class="modal fade" id="add-comment">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">

      <!-- Modal body -->
      <div class="modal-body">
        <div class="sign-up-form emgergency-form">
          <h2 class="text-center"><span> Post a Comment </span></h2>
          
            <div class="row">

              <div class="col-md-12">
               
                <div class="form-group-main">
                 
                <textarea class="form-control" placeholder="Add a comment..." [(ngModel)]="comment">

                </textarea>
                <div *ngIf="errorComment" class="alert alert-danger" >Please Enter Comment</div>
                <!-- <input type="button" (click)="addComment()" class="form-control btn btn-style" value="Add Comment"> -->
                </div>
              </div>

              
              <div class="col-md-12 text-center mt-3">
                <button style="font-size: 14px;"  (click)="addComment()" class="btn btn-style" >
                Add Comment  
                </button>
                
              </div>
            </div>
         
        </div>
      </div>
    </div>
  </div>
</div>
